<template>
  <div>
    <loading />
    <error-message ref="errorDialog" />
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import ErrorMessage from "@/components/parts/ApiErrorMessage.vue";

export default {
  components: { Loading, ErrorMessage },
  mounted() {
    // クエリにcallbackToが設定されている場合、設定されている値をコールバック先に入れる
    if (this.$route.query.hasOwnProperty("callbackTo")) {
      this.$store.commit(
        "setLoginCallbackRouteName",
        this.$route.query.callbackTo
      );
    } else {
      this.$store.commit("setLoginCallbackRouteName");
    }
    // クエリにcallbackQueryが設定されている場合、設定されている値をコールバック先に入れる
    if (this.$route.query.hasOwnProperty("callbackTo")) {
      this.$store.commit(
        "setLoginCallbackQuery",
        this.$route.query.callbackQuery
      );
    } else {
      this.$store.commit("setLoginCallbackQuery");
    }
    this.$http
      .get("/v1/twitter/auth-url")
      .then(response => {
        location.href = response.data.twitter_auth_url;
      })
      .catch(error => {
        this.$refs.errorDialog.setMessage(
          "認証用URLの取得に失敗しました。詳細：[" +
            error.response.status +
            "] " +
            error.response.statusText
        );
        // コールバック先をデフォルトに戻す
        this.$store.commit("setLoginCallbackRouteName");
        this.$router.push({
          name: "home",
          params: { response: error.response }
        });
      });
  }
};
</script>
